<!--
 * @Author: weixiuting weixiuting@qq.com
 * @Date: 2022-11-22 09:23:33
 * @LastEditors: weixiuting weixiuting@qq.com
 * @LastEditTime: 2023-09-26 17:20:58
 * @FilePath: \plantingSubsidy_web\src\views\statistics-charts\insurance-statistics\index.vue
 * @Description: 承保理赔一张图-统计承保统计图- 最新
-->
<template>
  <div class="container">
    <div class="top_container">
      <img src="./images/topImg.png" />
      <div class="time_box">统计时间：{{newDateTime}}</div>
      <div class="select_box"
           v-show="!orderVisible">

        <a-date-picker v-model="year"
                       :allowClear="false"
                       class="datePickerStyle"
                       dropdownClassName="datePickerDropStyle"
                       size="small"
                       format="YYYY年"
                       :inputReadOnly="true"
                       :open="open"
                       @openChange="openChange"
                       @panelChange="panelChange"
                       mode="year"
                       valueFormat="YYYY"
                       placeholder="请选择年份">

        </a-date-picker>
        <a-icon type="caret-down"
                class="dropIcon" />

      </div>

    </div>
    <!-- 保单开始 -->
    <transition name="orderList">
      <div class="body_container"
           v-show="orderVisible">
        <insurance-policy ref="insruancePolicyPage"
                          @back="handleInsurancePolicyBack" />
      </div>
    </transition>
    <!-- 保单结束 -->
    <transition name="chartList">
      <div class="body_container"
           v-show="!orderVisible">
        <!-- 第一列 -->
        <div class="left_box body_box1">
          <!-- 一行 -->
          <div class="box"
               style="flex:1;display:flex;flex-direction:column;justify-content:center;">
            <div class="title_bg title">投保农户情况</div>
            <total-statistics :year="year" />
          </div>
          <!-- 二行 -->
          <div class="box"
               style="height: 28%;display:flex;flex-direction:column;">
            <div class="title_bg_Long title">各作物承保情况 </div>
            <plant-insurance :year="year" />

          </div>
          <!-- 三行 -->
          <div class="box"
               style="height: 26%;display:flex;flex-direction:column;">
            <div class="title_bg_Long title">各地区承保情况 </div>
            <regional-rankings :year="year" />
          </div>
          <!-- 第四行 -->
          <div class="box"
               style="height: 26%;display:flex;flex-direction:column;">
            <div class="title_bg_Long title">各保险公司承保情况 </div>
            <regional-rankings barType="2"
                               :year="year" />
          </div>

        </div>
        <!-- 第二列 -->
        <div class="right_box"
             style="margin-top:0.2rem;">
          <div class="box"
               style="height: 70%;padding-top: 1.1rem;box-sizing: border-box;">
            <div class="title_bg_Long title"
                 style="padding-right:1.8rem;">各地区承保情况 <a-button ghost type="primary"
                        style="background:none;border:1px solid rgba(19, 125, 224, 0.35);color:#6FC4FF;border-radius:1rem !important;"
                        @click="handleSearchOrder">查询保单</a-button>
            </div>
            <!-- 左侧地图 -->
            <div style="display: flex;height:100%;">

              <div class="map_box"
                   style="width:78%;height:100%;position:relative;">
                <!-- 根据地区统计 -->
                <map-statistic ref="mapStatisticPage" />

                <map-chart @mapChartFun="handleMapChartClick"
                           :id="'mapId'" />
              </div>
              <!-- 右侧图表 -->
              <div class="right"
                   style="height: 100%;display:flex;flex-direction:column;position: relative;
    right: -3%;top:-3%;">
                <div style="height:23%;">
                  <chart-pie1 ref="echartDataPage1"></chart-pie1>
                </div>
                <div style="height:23%;">
                  <chart-pie1 ref="echartDataPage2"></chart-pie1>
                </div>
                <div style="height:23%;">
                  <chart-pie1 ref="echartDataPage3"></chart-pie1>
                </div>
                <div style="height:23%;">
                  <chart-pie1 ref="echartDataPage4"></chart-pie1>
                </div>
                <!-- 自定义图例 -->
                <div class="item_box">
                  <div class="item item_left">
                    完全成本
                  </div>
                  <div class="item item_right">
                    物化成本
                  </div>
                </div>

              </div>

            </div>

          </div>
          <!-- 下部分图表 -->
          <div class="bottom_box"
               style="height: 30%;display:flex;">
            <div class="part"
                 style="height: 100%;width:50%">
              <insurance-tend ref="insuranceTendPage" />

            </div>
            <div class="part"
                 style="height: 100%;width:50%">
              <company-insurance ref="companyInsurancePage" />

            </div>

          </div>

        </div>

      </div>
    </transition>
    <div class="bottom_container">
      <img src="./images/bottomImg.png" />

    </div>

  </div>

</template>
<script>
import { mapState } from 'vuex'
import moment from 'moment'
import InsurancePolicy from './InsurancePolicy'

import TotalStatistics from './components/v1/TotalStatistics' // 投保总户数
import PlantInsurance from './components/v1/PlantInsurance' // 各作物承保情况

import RegionalRankings from './components/v1/RegionalRankings'

import InsuranceTend from './components/v1/InsuranceTend'
import CompanyInsurance from './components/v1/CompanyInsurance'

import MapChart from './components/v1/Map/index'
import ChartPie1 from './components/v1/ChartPie/ChartPie1'
import MapStatistic from './components/v1/MapStatistic'

moment.locale('zh-cn') // 全国地图
export default {
  components: { InsurancePolicy, MapChart, MapStatistic, TotalStatistics, InsuranceTend, PlantInsurance, ChartPie1, RegionalRankings, CompanyInsurance },
  data () {
    return {
      newDateTime: moment(new Date()).add('year', 0).format('YYYY-MM-DD'),
      level: this.$store.state.account.user.level,
      account: this.$store.state.account,
      cityCode: '',
      year: moment(this.$route.query.year).format('YYYY').toString() || moment().format('YYYY').toString(), // 设置联动年度
      open: false,
      backParams: null, // 地图点击数据
      orderVisible: false // 显示查询保单
      /// //////////////////////////////////////////////////
      // echartData: {
      //   color: ['rgba(40, 166, 246, 1)', 'rgba(255, 221, 83, 1)', 'rgba(115, 240, 255, 1)', 'rgba(39, 73, 245, 1)'],
      //   count: 60,
      //   title: '水稻政策性保险',
      //   data: [{
      //     value: 0,
      //     name: '物化成本'
      //   }, {
      //     value: 0,
      //     name: '完全成本'
      //   }, {
      //     value: 0,
      //     name: '收入险'
      //   }, {
      //     value: 0,
      //     name: '价格险'
      //   }]
      // }
    }
  },
  created () {
    this.cityCode = this.account.userArea.city
  },

  mounted () {
    if (this.level <= 3) {
      // 政策保险完成比例
      this.getCbAcreage(
        {
          province: this.account.user.province || '230000000000',
          city: this.account.userArea.city || '',
          county: this.account.userArea.county || ''
        }
      )
    }
  },

  methods: {
    /* 查询保单 */
    handleSearchOrder () {
      this.orderVisible = true
    },
    /* 处理保单返回 */
    handleInsurancePolicyBack () {
      this.orderVisible = false
    },
    /* 切换年 */
    openChange (status) {
      if (status) {
        this.open = true
      } else {
        this.open = false
      }
    },
    panelChange (value) {
      this.year = moment(value).format('YYYY').toString()
      this.open = false
    },
    // 根据地区统计
    getStatistic (params) {
      this.$get('/statistics/statisticsBase/getInsuredAreaUsers', Object.assign({ year: this.year }, { ...params }))
        .then(r => {
          let data = r.data.data
          if (data.cbAcreage) {
            let statistic = {
              area: (data.cbAcreage / 10000).toFixed(2), // 总投保面积
              household: data.personCount // 总投保户数
            }
            this.$refs.mapStatisticPage.statistic = { ...statistic }
          }
          console.log('根据地区统计:', data)
        })
        .catch(() => { })
    },
    // 设置各种险种承保趋势
    getInsuranceTend (params) {
      this.$get('/statistics/statisticsBase/getInsureTrend', Object.assign({ year: this.year }, { ...params }))
        .then(r => {
          let data = r.data.data
          if (data.source && data.source.length > 0) {
            //       [
            //   { 'year': '2010', '物化成本': 200, '完全成本': 500, '收入险': 80, '价格险': 199 },
            //   { 'year': '2011', '物化成本': 200, '完全成本': 30, '收入险': 800, '价格险': 200 },
            //   { 'year': '2012', '物化成本': 200, '完全成本': 30, '收入险': 40, '价格险': 293 },
            //   { 'year': '2013', '物化成本': 560, '完全成本': 440, '收入险': 330, '价格险': 350 }
            // ]
            let dataSource1 = data.source.map(i => ({
              'year': i['YEAR'],
              '物化成本': Number((Number(i['whAcreage']) / 10000).toFixed(2)),
              '完全成本': Number((Number(i['wqAcreage']) / 10000).toFixed(2)),
              '收入险': Number((Number(i['srAcreage']) > 100 ? (Number(i['srAcreage']) / 10000).toFixed(2) : 0)),
              '价格险': Number((Number(i['jgAcreage']) > 100 ? (Number(i['jgAcreage']) / 10000).toFixed(2) : 0))

            }))
            this.$refs.insuranceTendPage.dataset.source = [...dataSource1]
            this.$refs.insuranceTendPage.initData()
            console.log('根据地区统计:', dataSource1)
          } else {
            this.$refs.insuranceTendPage.dataset.source = []
            this.$refs.insuranceTendPage.initData()
          }
        })
        .catch(() => { })
    },
    // 设置右侧 个保险险种 物化、完全……
    getAreaInsurance (params) {
      this.$get('/statistics/statisticsBase/getInsuranceCompleteRatioNew', Object.assign({ year: this.year }, { ...params }))
        .then(r => {
          let data = r.data.data
          if (data && data.dataset.length >= 0) {
            /* 水稻 */
            let dataList1 = [
              {
                value: Number((data.dataset[0].source[0].whAcreage / 10000).toFixed(2)),
                name: '物化成本'
              }, {
                value: Number((data.dataset[0].source[0].wqAcreage / 10000).toFixed(2)),
                name: '完全成本'
              }
              //  {
              //   value: Number((data.dataset[0].source[0].srAcreage / 10000).toFixed(2)),
              //   name: '收入险'
              // }, {
              //   value: Number((data.dataset[0].source[0].jgAcreage / 10000).toFixed(2)),
              //   name: '价格险'
              // }

            ]
            let percent1 = (Number(data.dataset[0].source[0].labelValue) / Number(data.dataset[0].source[0].plantAcreage) * 100).toFixed(2)
            if (data.dataset[0].source[0].plantAcreage === 0) percent1 = 0
            let chartData1 = {
              data: dataList1,
              count: percent1,
              title: '水稻政策性保险'
            }
            /* 玉米 */
            let dataList2 = [
              {
                value: Number((data.dataset[1].source[0].whAcreage / 10000).toFixed(2)),
                name: '物化成本'
              }, {
                value: Number((data.dataset[1].source[0].wqAcreage / 10000).toFixed(2)),
                name: '完全成本'
              }
              //  {
              //   value: Number((data.dataset[1].source[0].srAcreage / 10000).toFixed(2)),
              //   name: '收入险'
              // }, {
              //   value: Number((data.dataset[1].source[0].jgAcreage / 10000).toFixed(2)),
              //   name: '价格险'
              // }

            ]
            let percent2 = (Number(data.dataset[1].source[0].labelValue) / Number(data.dataset[1].source[0].plantAcreage) * 100).toFixed(2)
            if (data.dataset[1].source[0].plantAcreage === 0) percent2 = 0
            let chartData2 = {
              data: dataList2,
              count: percent2,
              title: '玉米政策性保险'
            }
            /* 大豆 */
            let dataList3 = [
              {
                value: Number((data.dataset[2].source[0].whAcreage / 10000).toFixed(2)),
                name: '物化成本'
              }, {
                value: Number((data.dataset[2].source[0].wqAcreage / 10000).toFixed(2)),
                name: '完全成本'
              }
              //  {
              //   value: Number((data.dataset[2].source[0].srAcreage / 10000).toFixed(2)),
              //   name: '收入险'
              // }, {
              //   value: Number((data.dataset[2].source[0].jgAcreage / 10000).toFixed(2)),
              //   name: '价格险'
              // }
            ]
            let percent3 = (Number(data.dataset[2].source[0].labelValue) / Number(data.dataset[2].source[0].plantAcreage) * 100).toFixed(2)
            if (data.dataset[2].source[0].plantAcreage === 0) percent3 = 0
            let chartData3 = {
              data: dataList3,
              count: percent3,
              title: '大豆政策性保险'
            }
            /* 小麦 */
            let dataList4 = [
              {
                value: Number((data.dataset[3].source[0].whAcreage / 10000).toFixed(2)),
                name: '物化成本'
              }, {
                value: Number((data.dataset[3].source[0].wqAcreage / 10000).toFixed(2)),
                name: '完全成本'
              }
              // {
              //   value: Number((data.dataset[3].source[0].srAcreage / 10000).toFixed(2)),
              //   name: '收入险'
              // }, {
              //   value: Number((data.dataset[3].source[0].jgAcreage / 10000).toFixed(2)),
              //   name: '价格险'
              // }
            ]
            let percent4 = (Number(data.dataset[3].source[0].labelValue) / Number(data.dataset[3].source[0].plantAcreage) * 100).toFixed(2)
            if (data.dataset[3].source[0].plantAcreage === 0) percent4 = 0
            let chartData4 = {
              data: dataList4,
              count: percent4,
              title: '小麦政策性保险'
            }

            console.log('chartData1:', chartData1)
            // let color = ['rgba(255, 221, 83, 1)', 'rgba(40, 166, 246, 1)', 'rgba(115, 240, 255, 1)', 'rgba(39, 73, 245, 1)']
            let color = ['rgba(250, 244, 71, 1)', 'rgba(39, 245, 122, 1)', 'rgba(115, 240, 255, 1)', 'rgba(39, 73, 245, 1)']
            let defaultColor = 'rgba(255,255,255,0.1)'

            this.$refs.echartDataPage1.echartData = { ...chartData1, color: ((chartData1 && chartData1.count) ? color : defaultColor) }
            this.$refs.echartDataPage2.echartData = { ...chartData2, color: ((chartData2 && chartData2.count) ? color : defaultColor) }
            this.$refs.echartDataPage3.echartData = { ...chartData3, color: ((chartData3 && chartData3.count) ? color : defaultColor) }
            this.$refs.echartDataPage4.echartData = { ...chartData4, color: ((chartData4 && chartData4.count) ? color : defaultColor) }
          }
          // this.setData(data)
        })
        .catch(() => { })
    },
    // 设置各保险公司承保情况
    getInsuranceCompany (params) {
      // let dataSource2 = [
      //   { companyName: '保险公司1', '': 1000, '承保面积': 1000 },
      //   { companyName: '保险公司2', '': 1000, '承保面积': 800 },
      //   { companyName: '保险公司3', '': 1000, '承保面积': 600 },
      //   { companyName: '保险公司4', '': 1000, '承保面积': 500 },
      //   { companyName: '保险公司5', '': 1000, '承保面积': 900 }
      // ]

      // this.$refs.companyInsurancePage.dataset.source = [...dataSource2]

      this.$get('/statistics/statisticsBase/getCbAcreage', Object.assign({ year: this.year }, { ...params }))
        .then(r => {
          let data = r.data.data
          let dataSource = []
          if (data && data.companyCbAcreage && data.companyCbAcreage.source && data.companyCbAcreage.source.length > 0) {
            // 设置最大值（背景柱）
            let max = data.companyCbAcreage.source.map(i => i['companyCbAcreage'])
            max = Number((max.sort((a, b) => (b - a))[0] / 10000).toFixed(2))
            dataSource = data.companyCbAcreage.source.map(i => ({
              companyName: i.headCompanyName,
              '': max,
              '承保面积': Number((i['companyCbAcreage'] / 10000).toFixed(2))
            }))
          }
          console.log('dataSource:', dataSource)

          this.$refs.companyInsurancePage.dataset.source = [...dataSource]
        })
        .catch(() => { })
    },
    getCbAcreage (params) { // year: moment().format('YYYY')
      // 各地区投保情况-联动

      // 设置各种险种承保趋势
      this.getInsuranceTend(params)

      // 设置各保险公司承保情况
      this.getInsuranceCompany(params)

      // 根据地区统计
      this.getStatistic(params)

      // 设置右侧 个保险险种 物化、完全……
      this.getAreaInsurance(params)
    },
    handleMapChartClick (backParams) {
      console.log('超出点击：', backParams)
      if (this.$store.state.account.user.level === 3) {
        // 区县账号点击 禁止操作
        return
      }
      // this.backParams = this.deepClone(backParams)
      this.backParams = backParams

      let level = backParams.level
      let queryparams = {}
      if (level === 0) {
        queryparams = {
          province: this.$store.state.account.user.province || '230000000000',
          city: '',
          county: ''
        }
      } else if (level === 1) {
        queryparams = {
          province: this.$store.state.account.user.province || '230000000000',
          city: backParams.value + '000000',
          county: ''
        }
      } else {
        queryparams = {
          province: this.$store.state.account.user.province || '230000000000',
          city: '',
          county: backParams.value + '000000'
        }
      }
      if (this.$store.state.account.user.level === 2) {
        // 市账号设置市编码
        queryparams.city = this.$store.state.account.userArea.city || ''
      }

      this.getCbAcreage(queryparams)
      // console.log(code, level)
    }
  },
  watch: {
    year: {

      handler (newVal) {
        if (newVal && this.level <= 3) {
          if (this.backParams) {
            this.handleMapChartClick(this.backParams)
          } else {
            this.getCbAcreage(
              {
                province: this.account.user.province || '230000000000',
                city: this.account.userArea.city || '',
                county: this.account.userArea.county || ''
              }
            )
          }
        }
      }

    }

  }

}
</script>
<style lang="less" scoped>
body {
  min-height: 700px;
  user-select: none !important;
  -webkit-user-select: none !important;
  div,
  span,
  p,
  h1,
  h2,
  h3,
  h4 {
    user-select: none !important;
    -webkit-user-select: none !important;
  }
  overflow: hidden;
}

@font-face {
  font-family: numFont;
  src: url(./fonts/ShiShangZhongHeiJianTi-1.ttf);
}
/* 自定义图例 */
.item_box {
  color: #fff;
  display: flex;
  position: absolute;
  width: 90%;
  justify-content: center;
  bottom: -5px;
}
.item {
  margin: 0 5px;
  font-size: 0.8rem;
  color: #c4e0fa;
  padding-left: 1rem;
  position: relative;
}

.item::before {
  display: block;
  position: absolute;
  left: 0;
  top: 0.3rem;
  content: "";
  width: 10px;
  height: 10px;
  background: white;
}
.item_left::before {
  background: rgba(39, 245, 122, 1);
}
.item_right::before {
  background: rgba(250, 244, 71, 1);
}
.container {
  width: 100%;
  min-width: 1900px;
  box-sizing: border-box;
  height: 100vh;
  // min-height: 1080px;
  background: url(./images/backgroundBg.png) repeat-y;
  background-size: 100% 100%;
  background-attachment: fixed;
  display: flex;
  flex-direction: column;
  .top_container {
    position: relative;
    height: 10vh;
    img {
      position: absolute;
      z-index: 1;
      width: 100%;
    }
    .time_box {
      position: absolute;
      top: 20px;
      left: 30px;
      font-size: 17px;
      color: #5ed3ff;
    }
    .select_box {
      position: absolute;
      top: 20px;
      right: 30px;
      font-size: 14px;
      .datePickerStyle {
        width: 100px;
        border: 1px solid #0ca3f1;
        border-radius: 40px;
        position: relative;
        z-index: 2;
        // background: #022542;
      }
      /deep/ .ant-calendar-picker-input.ant-input-sm {
        border: none;
        background: none;
        color: #0ca3f1 !important;
        padding-left: 16px;
        cursor: pointer;
        font-style: italic;
      }
      /deep/ .ant-calendar-picker-icon {
        display: none;
      }
      .dropIcon {
        position: absolute;
        z-index: 1;
        top: 5px;
        right: 10px;
        color: #0ca3f1;
      }
    }
  }
  .bottom_container {
    img {
      width: 100%;
      min-height: 37px;
    }
  }
  .body_container {
    // height: calc(100vh - 10rem);

    flex: 1;
    overflow: hidden;
    display: flex;
    align-items: center;
    .left_box {
      width: 54% !important;
      padding-left: 1rem;
      padding-right: 2%;
      height: 100%;
      display: flex;
      flex-direction: column;
    }
    .right_box {
      flex: 1;
      height: 100%;
      // margin-right: 0.4rem;
      margin-top: 0.6rem;
      background: linear-gradient(
        to right,
        rgba(6, 99, 182, 0.08),
        rgba(38, 138, 222, 0)
      );
    }
    .box {
      .left {
        padding-right: 3rem;
        position: relative;
        top: -1rem;
      }
      .right {
        flex: 1;
      }
    }

    .chart_box {
      flex: 1;
      flex-shrink: 0;
    }
    //   }

    .body_box1 {
      width: 27%;
      min-width: 520px;
      color: #fff;
    }
    .map_box {
      // flex: 1;
      height: 500px;
      .chart_box {
        position: relative;
        // top: -10%;
        // margin-left: -35px;
        // top: 35px;
        transform: scale(1.8);
      }
    }

    .title {
      color: #fff;
      font-size: 15px;
      // font-weight: bold;
      letter-spacing: 1px;
      padding-bottom: 14px;
      user-select: none !important;
      -webkit-user-select: none !important;
      height: 3rem;
    }
    .title_bg {
      background: url(./images/titleBgLong.png) no-repeat 100%;
      background-position: left center;
      padding: 14px 40px;
    }
    .title_bg_short {
      background: url(./images/titleBgShort.png) no-repeat 100%;
      background-position: left center;
      padding: 14px 40px;
    }
    .title_bg_Long {
      background: url(./images/titleBgLongLong.png) no-repeat 100%;
      background-position: left center;
      padding: 14px 40px;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }
}

/* 保单进入动画 */
.orderList-enter-active {
  animation: moveIn 1s;
}

/* 保单离开动画 */
.orderList-leave-active {
  // animation: move 0.1s reverse;
  animation: moveOut 0.1s;
  opacity: 0;
}
/* 图表进入动画 */
.chartList-enter-active {
  animation: move 1.5s;
}

/* 图表离开动画 */
.chartList-leave-active {
  // animation: move 0.1s reverse;
  animation: leave 0.3s;
}
@keyframes moveIn {
  from {
    transform: translateX(100%);
  }
  to {
    transform: translate(0);
  }
}
@keyframes moveOut {
  from {
    transform: translateX(0);
  }
  to {
    transform: translate(-100%);
  }
}

@keyframes move {
  from {
    // transform: translateX(-100%);
    opacity: 0;
  }
  to {
    // transform: translate(0);
    opacity: 1;
  }
}
@keyframes leave {
  from {
    // transform: translateX(0);
    opacity: 1;
  }
  to {
    // transform: translate(100%);
    opacity: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/statistics-charts/insurance-statistics/index.vue